import { push }                       from "connected-react-router";
import { getAccessRightsProps }       from "dmpconnectjsapp-base/rules/accessRights";
import moment                         from "moment";
import PropTypes                      from "prop-types";
import React, { useEffect, useState } from "react";
import { Button }                     from "react-bootstrap";
import { connect }                    from "react-redux";
import { getAATVitaleUrl }            from "../../../dmpconnect/helpers/nav";
import { getBaseName }                from "../../../dmpconnect/utils/redirect";
import TitleTooltip                   from "../../Common/TitleTooltip";

function AATButton ({ vitalePatient, tlsSubSection, dispatch, profession }) {
  const [isAuthorized, setIsAuthorized]   = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const authorizedRegime                  = ["01", "02", "04", "05"];
  
  useEffect(() => {
    const age = moment().diff(
      moment(vitalePatient.s_birthdayYYYYMMDD, "YYYYMMDD"),
      "years"
    );
    
    const errors = [];
    
    //TODO : add to validateJSONCommands generateaat
    if (
      vitalePatient.i_quality === 0 &&
      age >= 16 &&
      authorizedRegime.includes(vitalePatient.HealthCoverage.s_regime) &&
      [10, 40, 50].includes(Number(profession))
    ) {
      setIsAuthorized(true);
    } else {
      if (age < 16) {
        errors.push("le patient doit être âgé de 16 ans ou plus");
      }
      if (
        !authorizedRegime.includes(
          vitalePatient.HealthCoverage.s_regime
        )
      ) {
        return setErrorMessages(`Votre patient est affilié à un régime pour lequel la transmission n’est
pas possible. Il est recommandé de passer au circuit papier`);
      }
      if (vitalePatient.i_quality !== 0) {
        errors.push("le patient n'a pas le status d'assuré");
      }
      if (![10, 40, 50].includes(Number(profession))) {
        errors.push(
          "votre profession ne vous permet pas de réaliser un AAT"
        );
      }
      setErrorMessages(errors);
    }
  }, [profession, vitalePatient]);
  
  const formatErrorMessages = (errors) => {
    if (typeof errors === "string") {
      return errors;
    }
    if (errors.length === 0) {
      return "";
    }
    if (errors.length === 1) {
      return errors[0];
    }
    const errorsCopy = [...errors];
    const lastError  = errorsCopy.pop();
    return `${errorsCopy.join(", ")} et ${lastError}`;
  };
  
  return (
    <TitleTooltip
      id={`aat-button-${tlsSubSection}`}
      text={
        isAuthorized
          ? "Transmettre un Avis d'Arrêt de Travail"
          : `Avis d'Arrêt de Travail non autorisé pour ce patient pour le(s) motif(s) suivant(s) :
                    ${formatErrorMessages(errorMessages)}.`
      }
    >
      <div className="d-inline-block">
        <Button
          className="btn-icon-only"
          type="button"
          variant="link"
          size="sm"
          onClick={() => dispatch(push(getAATVitaleUrl(tlsSubSection)))}
          disabled={!isAuthorized}
        >
          <img
            src={`${getBaseName(false)}/images/logo/aat-logo.png`}
            alt="AAT"
            style={{ cursor: "pointer", height: "50px" }}
          />
        </Button>
      </div>
    </TitleTooltip>
  );
}

function mapStateToProps (state) {
  const {
          accessRights: { profession }
        } = getAccessRightsProps(state);
  return {
    profession
  };
}

export default connect(mapStateToProps)(AATButton);

AATButton.propTypes = {
  dispatch     : PropTypes.func.isRequired,
  tlsSubSection: PropTypes.string.isRequired,
  vitalePatient: PropTypes.object.isRequired,
};
